// ----------------------------------------------------------------------------
// Template: 404
// ----------------------------------------------------------------------------
// 404 File Not Found Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-hero/page-hero';
import 'sections/main-404/main-404';